<template>
  <div>
    <main>
      <div class="container">
        <div class="row">
          <div
              class="col_xl_8 xl_offset_2 col_l_8 l_offset_2 col_m_12 col_s_12"
          >
            <p class="tac terms_title">Your first meeting system</p>

            <h3 class="tac pricing_h3">
              Use easily accessible and secure meetings for your personal and
              business needs! Built for everyone!
            </h3>

            <router-link to="/pricing" class="color_btn hover_op return_home"
            >Try for free
            </router-link>

            <div class="img_wrap">
              <img src="@/assets/img/try_1.png" alt=""/>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="text_block w522">
                <p class="big tac">Audio and video calls</p>

                <h3 class="tac">
                  You don't have to start from scratch every time. Create rooms
                  that you can use instantly.
                </h3>
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="img_wrap w522 right">
                <img src="@/assets/img/try_2.png" alt=""/>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_2 order_s_2">
              <div class="img_wrap w522">
                <img src="@/assets/img/try_3.png" alt=""/>
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_1 order_s_1">
              <div class="text_block w522 right">
                <p class="big tac">Screen sharing</p>

                <h3 class="tac">
                  Share your screen during a call and keep everyone in the
                  meeting on one page for a productive conversation.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="text_block w522">
                <p class="big tac">Smart messages</p>

                <h3 class="tac">
                  Respond instantly to any message with positive reactions or
                  use @mentions to address someone in particular.
                </h3>
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="img_wrap w522 right">
                <img src="@/assets/img/try_4.png" alt=""/>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div
                class="col_xl_8 xl_offset_2 col_l_8 l_offset_2 col_m_12 col_s_12"
            >
              <p class="tac easier">Easier than usual</p>

              <p class="tac pseudo_link_title">
                You can use your own meeting names and share them in seconds.
              </p>

              <div class="pseudo_link">http://getsynced.io/edithanderson</div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_2 order_s_2">
              <div class="img_wrap w522">
                <img src="@/assets/img/try_5.png" alt=""/>
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_1 order_s_1">
              <div class="text_block w522 right">
                <p class="big tac">Voice intelligence</p>

                <h3 class="tac">
                  Built-in artificial intelligence technology provides a
                  complete transcription of your conversation into full text for
                  further processing.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="text_block w522">
                <p class="big tac">Recording calls made easy</p>

                <h3 class="tac">
                  Record every detail of the videoconference for further
                  analysis. Freely share records with each other.
                </h3>
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="img_wrap w522 right">
                <img src="@/assets/img/try_6.png" alt=""/>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_2 order_s_2">
              <div class="img_wrap w522">
                <img src="@/assets/img/try_7.png" alt=""/>
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_1 order_s_1">
              <div class="text_block w522 right">
                <p class="big tac">
                  Completely <br/>
                  private
                </p>

                <h3 class="tac">
                  Be confidential in conversations with standard end-to-end
                  encryption.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div
                class="col_xl_8 xl_offset_2 col_l_8 l_offset_2 col_m_12 col_s_12"
            >
              <p class="big tac feedback_title">
                A place that connects people. We want to see your smile!
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col_xl_4 col_l_4 m_hide s_hide">
              <div class="feedback_wrap">
                <div class="stars">
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                </div>

                <p class="tac feedback_text">
                  GetSynced is perfect because I can chat with friends whenever
                  I want.
                </p>

                <p class="tac feedback_name">Craig Hernandez</p>
              </div>
            </div>

            <div class="col_xl_4 col_l_4 m_hide s_hide">
              <div class="feedback_wrap with_border">
                <div class="stars">
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                </div>

                <p class="tac feedback_text">
                  What a great way to be with so many family members, friends
                  and classmates! I will gladly recommend for daily use.
                </p>

                <p class="tac feedback_name">Lottie Diaz</p>
              </div>
            </div>

            <div class="col_xl_4 col_l_4 m_hide s_hide">
              <div class="feedback_wrap with_border">
                <div class="stars">
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  <img src="@/assets/img/star_half_icon.svg" alt=""/>
                </div>

                <p class="tac feedback_text">
                  I like that GetSynced is very easy to use. It is a lifesaver
                  for families and businesses in these difficult days.
                </p>

                <p class="tac feedback_name">Rodney Johnson</p>
              </div>
            </div>

            <div class="col_s_12 col_m_12 l_hide xl_hide">
              <carousel :items="1" :nav="false" :dots="true">
                <div class="feedback_wrap">
                  <div class="stars">
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                  </div>

                  <p class="tac feedback_text">
                    GetSynced is perfect because I can chat with friends
                    whenever I want.
                  </p>

                  <p class="tac feedback_name">Craig Hernandez</p>
                </div>

                <div class="feedback_wrap">
                  <div class="stars">
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_half_icon.svg" alt=""/>
                  </div>

                  <p class="tac feedback_text">
                    I like that GetSynced is very easy to use. It is a lifesaver
                    for families and businesses in these difficult days.
                  </p>

                  <p class="tac feedback_name">Rodney Johnson</p>
                </div>

                <div class="feedback_wrap">
                  <div class="stars">
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_filled_icon.svg" alt=""/>
                    <img src="@/assets/img/star_half_icon.svg" alt=""/>
                  </div>

                  <p class="tac feedback_text">
                    I like that GetSynced is very easy to use. It is a lifesaver
                    for families and businesses in these difficult days.
                  </p>

                  <p class="tac feedback_name">Rodney Johnson</p>
                </div>
              </carousel>
            </div>
          </div>
        </div>
      </section>

      <section class="build_room">
        <div class="container">
          <div class="row">
            <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
              <p class="big tac">
                Don't miss the chance to <br/>
                make your chat perfect
              </p>

              <h3 class="tac middle">Together we overturn mountains</h3>
            </div>
          </div>

          <div class="row">
            <div
                class="
                col_xl_2
                xl_offset_5
                col_l_2
                l_offset_5
                col_m_4
                m_offset_4
                col_s_12
              "
            >
              <router-link to="/pricing" class="color_btn hover_op try_free"
              >Try for free
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </main>

    <footerComponent></footerComponent>
  </div>
</template>

<script>
import Axios from "axios";
import footerComponent from "@/components/footerComponent.vue";
import carousel from "vue-owl-carousel2";

export default {
  name: "Home",
  components: {
    footerComponent,
    carousel,
  },

  data() {
    return {
      feedback: [
        {
          stars: 5,
          text: "GetSynced is perfect because I can chat with friends whenever I want.",
          name: "Craig Hernandez",
        },

        {
          stars: 4,
          text: "What a great way to be with so many family members, friends and classmates! I will gladly recommend for daily use.",
          name: "Lottie Diaz",
        },

        {
          stars: 4,
          text: "I like that GetSynced is very easy to use. It is a lifesaver for families and businesses in these difficult days.",
          name: "Rodney Johnson",
        },
      ],

      rooms: [],

      content: 's;klfjsdfjsdlkfdj <a href="asdasd">asdasd</a>',
    };
  },
};
</script>

<style lang="scss">
.owl-theme .owl-nav.disabled + .owl-dots {
  margin-top: 64px;
  height: 8px;
  line-height: 0;
}

.owl-theme .owl-dots .owl-dot {
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background-color: #000;
  opacity: 0.16;
  transition: opacity 180ms;

  span {
    display: none !important;
  }

  & + .owl-dot {
    margin-left: 16px;
  }

  &.active {
    opacity: 1;
    transition: opacity 180ms;
  }
}

.pseudo_link_title {
  font-family: "Playfair Display", serif;
  font-size: 36px;
  font-weight: 400;
  line-height: 48px;
  margin-bottom: 64px;

  @media all and (max-width: 767px) {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 32px;
  }
}

.easier {
  color: #5c5c5c;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 32px;

  @media all and (max-width: 767px) {
    margin-bottom: 16px !important;
  }
}

.pseudo_link {
  pointer-events: none;
  user-select: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  border-radius: 16px;
  background-color: #fff;
  padding: 16px;
  color: #fc5a12;
  font-family: "Nunito Sans", sans-serif;
  font-weight: 700;
  line-height: 32px;

  @media all and (max-width: 767px) {
    height: auto;
    font-size: 24px;
    line-height: 28px;
    word-break: break-all;
  }
}

.feedback_wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  &.with_border {
    &:before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: -16px;
      width: 1px;
      background-color: #000;
    }

    @media all and (max-width: 767px) {
      &:before {
        display: none;
      }
    }
  }
}

.feedback_name {
  color: #fc5a12;
  font-family: "Nunito Sans", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
}

.stars {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 64px;

  @media all and (max-width: 767px) {
    margin-bottom: 32px;
  }

  img {
    height: 24px;

    & + img {
      margin-left: 16px;
    }
  }
}

.feedback_text {
  max-width: 255px;
  margin-bottom: 64px;
  color: #5c5c5c;
  font-family: "Nunito Sans", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  flex: 1 1 auto;

  @media all and (max-width: 767px) {
    margin-bottom: 32px;
    max-width: none;
  }
}
</style>
